import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Tooltip,
  IconButton,
  InputBase,
  Button,
  Dialog,
  DialogContent,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseB2BCustomer } from "./UseB2BCustomer";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import FilterSearch from "./FilterSearch";

export default function B2BCustomers() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const {
    updateCustomer,
    getCustomerList,
    deleteCustomer,
    addCustomer,
    getCustomerByID,
  } = UseB2BCustomer();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [userDetails, setUserDetails] = useState();
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [userRes, setCustomerRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });

  const [state, setState] = useState({
    orgenizeID: undefined,
    orgenizeTypeID: undefined,
    suspend: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getCustomerList(
      state,
      myPc,
      search,
      (users) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(users.totalPage);
          return;
        }
        setCustomerRes(users);
      },
      true
    );
  }, [myPc, state]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return setOpen(true);
  };

  const columns = [
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "firstName",
      headerName: "نام",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.firstName}
          </Typography>
        );
      },
    },
    {
      field: "lastName",
      headerName: "نام خانوادگی",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.lastName}
          </Typography>
        );
      },
    },

    {
      field: "mobile",
      headerName: "شماره موبایل",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "orgenize",
      headerName: "سازمان",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.orgenize}
          </Typography>
        );
      },
    },
    {
      field: "orgenizeName",
      headerName: "نام سازمان",
      width: 140,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.orgenizeName}
          </Typography>
        );
      },
    },
    {
      field: "orgenizeType",
      headerName: "نوع سازمان",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.orgenizeType}
          </Typography>
        );
      },
    },
    {
      field: "managerName",
      headerName: "نام مدیر",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.managerName}
          </Typography>
        );
      },
    },
    {
      field: "suspendTitle",
      headerName: "وضعیت",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.suspendTitle}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 100,
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex" }}>
            <Box>
              {cellValues.row.suspend == 1 ? (
                <Tooltip title="عملیات تعلیق">
                  <IconButton
                    sx={{ p: 0.5 }}
                    onClick={() =>
                      setCheckState({
                        show: true,
                        suspend: 0,
                        id: cellValues.row.id,
                        model: cellValues.row,
                        name:
                          "عدم تعلیق کاربر " +
                          cellValues.row.firstName +
                          " " +
                          cellValues.row.lastName,
                      })
                    }
                  >
                    <LockIcon fontSize="small" color="secondary" />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="عملیات تعلیق">
                  <IconButton
                    sx={{ p: 0.5 }}
                    onClick={() =>
                      setCheckState({
                        show: true,
                        suspend: 1,
                        id: cellValues.row.id,
                        model: cellValues.row,
                        name:
                          " تعلیق کاربر " +
                          cellValues.row.firstName +
                          " " +
                          cellValues.row.lastName,
                      })
                    }
                  >
                    <LockOpenIcon fontSize="small" color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Tooltip title="Delete">
              <IconButton
                sx={{ p: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name:
                      cellValues.row.firstName + " " + cellValues.row.lastName,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                sx={{ p: 0.5 }}
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());

                  return navigate("/b2bcustomers/editCustomer", {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      headerAlign: "center",
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "مارکتینگ",
        childs: [{ name: msActiveMenu.pageTitle, url: "/b2bcustomers" }],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box
          sx={{
            mb: 1,
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <FilterSearch setState={setState} state={state} />
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          {userRes ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={userRes.pageCondition.pageCount}
              rows={userRes && userRes.items ? userRes.items : []}
              paginationMode="server"
              page={userRes.pageCondition.page - 1}
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={
                userRes?.pageCondition.totalItemCount
                  ? userRes.pageCondition.totalItemCount
                  : 1
              }
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  scrollTo: myPc.scrollTo,
                  newFunc: newFunc,
                  isLtr: true,
                  rowCount: userRes?.pageCondition.totalItemCount
                    ? userRes.pageCondition.totalItemCount
                    : "",
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: {
                  page: myPc.page,
                },
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
      </Box>
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"مشتری"}
        callback={() => {
          setProgress(true);
          deleteCustomer(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          let state = {
            id: checkState.model.id,
            firstName: checkState.model.firstName,
            lastName: checkState.model.lastName,
            mobile: checkState.model.mobile,
            managerName: checkState.model.managerName,
            orgenizeName: checkState.model.orgenizeName,
            comericalCode: checkState.model.comericalCode,
            orgenizeID: checkState.model.orgenizeID,
            orgenizeTypeID: checkState.model.orgenizeTypeID,
            suspend: checkState.model.suspend,
            isColleague: checkState.model.isColleague,
            suspend: checkState.suspend,
          };
          setProgress(true);
          updateCustomer(state, () => {
            setProgress(true);
            getCustomerList(
              state,
              myPc,
              search,
              (users) => {
                setCustomerRes(users);
              },
              false
            );
          });
        }}
      />
      <Dialog
        open={open}
        maxWidth={userDetails ? "sm" : "xs"}
        fullWidth
        sx={{
          "& .MuiPaper-root ": {
            height: "30",
          },
        }}
        onClose={() => {
          setUserDetails();
          setState("");
          setOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: userDetails ? "row" : "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <TextField
              size="small"
              autoFocus
              id="outlined-basic"
              value={state ? state : ""}
              sx={{
                input: {
                  textAlign: "center",
                },
              }}
              label=" موبایل"
              placeholder="شماره موبایل را وارد کنید"
              fullWidth
              variant="outlined"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setProgress(true);
                  getCustomerByID(0, state, (user) => {
                    setUserDetails(user);
                  });
                }
              }}
              onChange={(event) => setState(event.target.value)}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >
              <Button
                sx={{ width: "80px" }}
                size="small"
                variant="contained"
                onClick={() => {
                  setProgress(true);
                  getCustomerByID(0, state, (user) => {
                    setUserDetails(user);
                  });
                }}
              >
                جستجو
              </Button>
              {!userDetails && (
                <Button
                  size="small"
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setState("");
                    setOpen(false);
                  }}
                >
                  انصراف
                </Button>
              )}
            </Box>
          </Box>
          {userDetails && (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                justifyContent: "center",
                mt: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <TextField
                  sx={{
                    width: "50%",
                  }}
                  label="مشتری"
                  value={
                    userDetails
                      ? userDetails.firstName + " " + userDetails.lastName
                      : ""
                  }
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                />
                <TextField
                  sx={{
                    width: "50%",
                  }}
                  label="نام سازمان"
                  value={userDetails ? userDetails.orgenizeName : ""}
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                />
                <TextField
                  sx={{
                    width: "30%",
                  }}
                  label="همکار"
                  value={userDetails.isColleague == true ? "است" : "نیست"}
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => {
                    setProgress(true);
                    addCustomer(userDetails.id, () => {
                      setProgress(true);
                      getCustomerList(
                        state,
                        myPc,
                        search,
                        (users) => {
                          setCustomerRes(users);
                        },
                        false
                      );
                      setState("");
                      setUserDetails();
                      setOpen(false);
                    });
                  }}
                >
                  افزودن
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setUserDetails();
                    setState("");
                    setOpen(false);
                  }}
                >
                  انصراف
                </Button>
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Detail>
  );
}
